// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "svg path[data-v-0eaaf85c],svg rect[data-v-0eaaf85c]{fill:#6c48e9}", ""]);
// Exports
module.exports = exports;
